"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get AbilityRuleSchema () {
        return AbilityRuleSchema;
    },
    get EMR_ABILITY_ACTIONS () {
        return EMR_ABILITY_ACTIONS;
    },
    get EMR_ABILITY_SUBJECTS () {
        return EMR_ABILITY_SUBJECTS;
    },
    get MyAbilitiesResponseSchema () {
        return MyAbilitiesResponseSchema;
    }
});
const _zod = require("zod");
const EMR_ABILITY_ACTIONS = [
    'manage',
    'create',
    'read',
    'update',
    'delete',
    'invite',
    'upload',
    'export'
];
const EMR_ABILITY_SUBJECTS = [
    'all',
    'User',
    'Role',
    'Permission',
    'MfaSettings',
    'AuditEvent',
    'Patient',
    'Encounter',
    'SoapNote',
    'Prescription',
    'Vitals',
    'Attachment',
    'Appointment',
    'LabResult',
    'Branch',
    'PrescriberProfile',
    'DoctorAvailability',
    'FpeRecord',
    'LabResultQuarantine',
    'LabSyncStatus',
    'LabResultPatient'
];
const AbilityRuleSchema = _zod.z.object({
    action: _zod.z.union([
        _zod.z.string().min(1),
        _zod.z.array(_zod.z.string().min(1)).min(1)
    ]),
    subject: _zod.z.union([
        _zod.z.string().min(1),
        _zod.z.array(_zod.z.string().min(1)).min(1)
    ]),
    conditions: _zod.z.record(_zod.z.string(), _zod.z.unknown()).optional(),
    inverted: _zod.z.boolean().optional()
});
const MyAbilitiesResponseSchema = _zod.z.object({
    rules: _zod.z.array(AbilityRuleSchema)
});
